export const REDIRECT_TO_SIGN_IN = 'REDIRECT_TO_SIGN_IN';
export const SET_PAGE_CONFIG = 'SET_PAGE_CONFIG';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
